<template>
  <div ref="container">
    <a-modal :title="title" width="96%" height="90%" :visible="visible" :confirmLoading="confirmLoading"
    :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()"
    :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:1%;height: 70%;">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          关闭
        </a-button>
        <a-button type="primary" @click="handleOk">
          确认
        </a-button>
      </template>
      <a-spin :spinning="confirmLoading">
        <a-form-model ref="form" :model="form" :rules="rules">
          <a-row class="form-row" :gutter="24">
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报告单号" prop="code">
                <a-input placeholder="请输入报告单号" v-model="form.code"/>
                <!-- onblur="isRepeat" -->
              </a-form-model-item>
            </a-col>
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报告日期" prop="date">
                <JDate placeholder="请填写报告日期" v-model="form.date" ></JDate>
              </a-form-model-item>
            </a-col>
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="受理人" prop="acceptedBy">
                <a-input placeholder="请输入受理人" v-model="form.acceptedBy" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品编号" prop="productNumber">
                <a-input placeholder="请输入产品编号" v-model="form.productNumber" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品名称" prop="productName">
                <a-input placeholder="请输入产品名称" v-model="form.productName" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规格型号" prop="productModel">
                <a-input placeholder="请输入规格型号" v-model="form.productModel" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品注册证号" prop="licenseNumber">
                <a-input placeholder="请输入产品注册证号" v-model="form.licenseNumber" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="注册人/备案人" prop="regBy">
                <a-input placeholder="请输入注册人/备案人" v-model="form.regBy" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产企业许可证" prop="licenseNumber">
                <a-input placeholder="请输入生产企业许可证" v-model="form.licenseNumber" />
              </a-form-model-item>
            </a-col>
            
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="批号/序列号" prop="serialNumber">
                <a-input placeholder="请输入批号/序列号" v-model="form.serialNumber" />
              </a-form-model-item>
            </a-col>
            
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产日期" prop="productDate">
                <JDate placeholder="请填写生产日期" v-model="form.productDate" ></JDate>
              </a-form-model-item>
            </a-col>
            
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量" prop="number">
                <a-input placeholder="请输入数量" v-model="form.number" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="使用单位" prop="unit">
                <a-input placeholder="请输入使用单位" v-model="form.unit" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="事故情况" prop="info">
                <a-textarea placeholder="请输入事故情况" v-model="form.info" :autoSize="{ minRows: 3 }"></a-textarea>
              </a-form-model-item>
            </a-col>
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="使用单位意见" prop="comOpinion">
                <a-textarea placeholder="请输入使用单位意见" v-model="form.comOpinion" :autoSize="{ minRows: 3 }"></a-textarea>
              </a-form-model-item>
            </a-col>
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="质量负责人意见" prop="personOpinion">
                <a-textarea placeholder="请输入质量负责人意见" v-model="form.personOpinion" :autoSize="{ minRows: 3 }"></a-textarea>
              </a-form-model-item>
            </a-col>
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理情况" prop="handle">
                <a-textarea placeholder="请输入处理情况" v-model="form.handle" :autoSize="{ minRows: 3 }"></a-textarea>
              </a-form-model-item>
            </a-col>
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" prop="remark">
                <a-textarea placeholder="请输入备注" v-model="form.remark" :autoSize="{ minRows: 3 }"></a-textarea>
              </a-form-model-item>
            </a-col>
            <!-- <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                <j-image-upload v-model="fileList" bizPath="material" text="上传" isMultiple></j-image-upload>
              </a-form-model-item>
            </a-col> -->
          </a-row>
        </a-form-model>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import JImageUpload from '@/components/jeecg/JImageUpload'
import pick from 'lodash.pick'
import { addAdverse, editAdverse, generateCode } from '@/api/api'
import { autoJumpNextInput } from '@/utils/util'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import JDate from '../../../components/jeecg/JDate.vue'
export default {
  name: 'VendorModal',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
      JImageUpload,
      JDate,
  },
  data() {
    return {
      title: '操作',
      visible: false,
      fileList: '',
      model: {},
      isReadOnly: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
      confirmLoading: false,
      form: {
        code: '',
      },
      uploadHeaders: {},
      action: window._CONFIG['domianURL'] + '/systemConfig/upload',
      rules: {
        code: [{ required: true, message: '请输入单据编号' }],
        date: [{ required: true, message: '请选择单据日期' }],
        department: [{ required: true, message: '请输入申请部门' }],
        preparedBy: [{ required: true, message: '请输入制单人' }],
        preparedTime: [{ required: true, message: '请输入单据时间' }],
      },
      id: '',
    }
  },
  created() {},
  methods: {
    //单据编号验重
    isRepeat(){
      console.log('000')
    },
    add() {
      this.generateCode()
      this.edit({})
      this.id = ''
    },
    edit(record) {
      if (this.$refs.form !== undefined) this.$refs.form.resetFields()
      console.log(this.form, 'form')
      console.log(this.fileList, '数组')
      if (record.id) {
        this.id = record.id
        this.form = { ...this.form, ...record } // 合并保留初始字段
      } else {
        this.fileList = ''
        // 重置表单但保留初始结构
        this.form = Object.assign({}, this.$options.data().form)
      }
      this.visible = true
      this.$nextTick(() => {})
    },
    
    // 生成单号
    generateCode(){
      generateCode().then(res => {
        if (res.code == 200 && res.success == true) {
          this.form.code = res.result
        } else {
          this.$message.error(res.message)
        }
      })

    },
    handleChange({ file, fileList }) {
      console.log(file, 'file')
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      that.$refs['form'].validate(async (success) => {
        if (success === true) {
          console.log(this.form, 'form---')
          // console.log(this.fileList, '图片数组')
          // if (this.fileList.length == 0) return this.$message.warning('请上传至少一张图片')
          let params = {
              code: this.form.code || '',
              date: this.form.date || '',
              acceptedBy: this.form.acceptedBy || '',
              productNumber: this.form.productNumber || '',
              productName: this.form.productName || '',
              productModel: this.form.productModel || '',
              licenseNumber: this.form.licenseNumber || '',
              regBy: this.form.regBy || '',
              licenseNumber: this.form.licenseNumber || '',
              serialNumber: this.form.serialNumber || '',
              productData: this.form.productData || '',
              number: this.form.number || '',
              unit: this.form.unit || '',
              remark: this.form.remark || '',
              info: this.form.info || '',
              comOpinion: this.form.comOpinion || '',
              personOpinion: this.form.personOpinion || '',
              handle: this.form.handle || '',
          }
          if (this.id) {
            // 编辑
            params.id = this.id
            const res = await editAdverse(params)
            console.log(res, 'res')
            if (res.code == 200 && res.success == true) {
              this.$message.success(res.result)
              this.handleCancel()
              this.$emit('ok')
            } else {
              this.$message.error(res.data || res.message)
            }
          } else {
            const res = await addAdverse(params)
            console.log(res, 'res')
            if (res.code == 200 && res.success == true) {
              this.$message.success(res.result)
              this.close()
              this.$emit('ok')
            } else {
              this.$message.error(res.data || res.message)
            }
          }
        }
      })
    },
    handleCancel() {
      this.close()
    },
    validateSupplierName(rule, value, callback) {
      let params = {
        name: value,
        type: '供应商',
        id: this.model.id ? this.model.id : 0,
      }
      checkSupplier(params).then((res) => {
        if (res && res.code === 200) {
          if (!res.data.status) {
            callback()
          } else {
            callback('名称已经存在')
          }
        } else {
          callback(res.data)
        }
      })
    },
  },
}
</script>
<style scoped>
</style>